import { TUseSearchParams } from '@/hooks/use-search-params.ts';
import { Button } from '@/components/ui/button.tsx';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { IProductsRes } from '@/types/models.ts';

function getPaginationFrom(pagination: IProductsRes['pagination']) {
  if (!pagination.start) {
    return 1;
  }
  return pagination.start + 1;
}

function getPaginationTo(pagination: IProductsRes['pagination']) {
  if (!pagination) {
    return 1;
  }
  let to = pagination.start + pagination.per_page;
  if (to > pagination.total) {
    to = pagination.total;
  }
  return to;
}

export function getProductsShowingText(data?: IProductsRes) {
  if (!data || !data.pagination) {
    return '';
  }
  return `Showing ${getPaginationFrom(data.pagination)} to ${getPaginationTo(data.pagination)} of ${data.pagination.total} Products`;
}

export function Pagination({ data, useSearch }: { data: IProductsRes; useSearch: TUseSearchParams }) {
  const nextPage = () => {
    const currentStart = data?.pagination.start || 0;
    const perPage = data?.pagination.per_page || 24;
    const newStart = currentStart + perPage;
    useSearch.setParams({ start: newStart } as any);
  };
  const prevPage = () => {
    const currentStart = data?.pagination.start || 0;
    const perPage = data?.pagination.per_page || 24;
    let newStart = currentStart - perPage;
    if (newStart < 0) {
      newStart = 0;
    }
    useSearch.setParams({ start: newStart } as any);
  };
  if (!data.pagination) {
    return null;
  }
  return (
    <div className="flex flex-col justify-center text-center">
      <div>{getProductsShowingText(data)}</div>
      <div className="flex items-center gap-2 justify-center my-4">
        <Button variant="outline" disabled={data.pagination.start === 0} onClick={prevPage}>
          <ChevronLeftIcon />
        </Button>
        <Button
          variant="outline"
          disabled={getPaginationTo(data.pagination) >= data.pagination.total}
          onClick={nextPage}
        >
          <ChevronRightIcon />
        </Button>
      </div>
    </div>
  );
}
